module.exports = __webpack_public_path__ + "img/20190617162354QQ截图20190612162616.a0e0bf05.png";